import { Filter } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { NotificationBadge } from '@/shared/ui';

import { useHeaderFilters } from '../model/use-header-filters';
import { FilterPanel } from './filter-panel';

export function FilterTrigger() {
  const [isOpen, setIsOpen] = useState(false);
  const { filterConfig } = useHeaderFilters();

  if (!filterConfig) return null;

  const triggerButton = (
    <Button variant="outline" className="relative h-9 gap-2">
      <Filter className="w-4 h-4" />
      <NotificationBadge count={filterConfig.activeCount} />
    </Button>
  );

  return (
    <FilterPanel
      open={isOpen}
      onOpenChange={setIsOpen}
      title={filterConfig.title}
      trigger={triggerButton}
      onApply={filterConfig.onApply}
      onReset={filterConfig.onReset}
      isApplyDisabled={filterConfig.isApplyDisabled}
      isResetDisabled={filterConfig.isResetDisabled}>
      {filterConfig.content}
    </FilterPanel>
  );
}
